var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64756 11.3363L3.86075 9.39725C3.69622 9.33314 3.57763 9.23535 3.50498 9.10387C3.43232 8.97239 3.396 8.83777 3.396 8.70002C3.396 8.56228 3.43579 8.42717 3.51539 8.29469C3.59499 8.16221 3.71705 8.06392 3.88158 7.99981L15.2899 3.72815C15.4386 3.6657 15.5826 3.65348 15.722 3.6915C15.8614 3.72953 15.9818 3.79924 16.0832 3.90064C16.1847 4.00203 16.2544 4.12244 16.2924 4.26187C16.3304 4.40129 16.3181 4.54529 16.2554 4.69387L11.967 16.097C11.9043 16.258 11.8071 16.3787 11.6755 16.4591C11.5438 16.5396 11.409 16.5799 11.2711 16.5799C11.1332 16.5799 10.9978 16.5421 10.8649 16.4664C10.732 16.3908 10.6339 16.271 10.5706 16.1071L8.64756 11.3363ZM11.2437 14.4485L14.7149 5.26904L5.51933 8.72417L9.60266 10.3652L11.2437 14.4485Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocate);
export default __webpack_public_path__ + "static/media/Locate.08e1dc7d5b3af604c59f791f04a60f39.svg";
export { ForwardRef as ReactComponent };